import * as navigate from 'app/area/shared/navigation';
import { ApplicationState } from 'app/types-store';
import { ActionDispatching } from 'app/types-shared';
import { actionCreators as responseCachingActionCreators } from 'app/area/shared/response-caching/actions';
import { CreateNewDraft, CreateNewDraftFailure } from './action-types';
import { ErrorNotification } from 'app/infrastructure/notifications/user-messages';
import { createDescriptionSelector } from 'app/infrastructure/translate/translate';
import { HttpStatusCodes } from 'app/infrastructure/remote-data';
import { headerTranslation } from 'app/shell/constants';
import { isCaseViewModalOpen } from 'app/components/helpers';

const isValidParent = (parentConnection) => parentConnection && (parentConnection.draftId || parentConnection.caseId)
  && parentConnection.connectionTypeId;

type ParentConnection = { draftId: number; connectionTypeId: number; caseId: number };

export const actionCreators = (api: any) => ({

  createCase: (caseTypeId: number, caseContextId?: number, parentConnection?: ParentConnection, entityPath?: any[]):
    ActionDispatching<any, ApplicationState> =>
    async (dispatch: any, getState: () => ApplicationState) => {

      let copyFrom = undefined;
      const state = getState();
      const translate = createDescriptionSelector(state.app.texts);

      if (isValidParent(parentConnection)) {
        const entityId = parentConnection.draftId ? parentConnection.draftId : parentConnection.caseId;
        const entityName = parentConnection.draftId ? 'draftId' : 'caseId';
        copyFrom = {
          source: {
            [entityName]: entityId,
            entityPaths: [entityPath]
          },
          context: { connectionTypeId: parentConnection.connectionTypeId }
        };
      }

      const utcOffset = state.app.settings.utcOffset;
      const caseDraftParameters = navigate.caseDraftParametersFromSearchParams(new URLSearchParams(location.search));

      try {
        dispatch(new CreateNewDraft(caseTypeId));
        const body: any = { caseTypeId, copyFrom, caseContextId, caseDraftParameters };
        if (caseContextId) {
          body.caseContextId = caseContextId;
        }

        const { location: draftId, response } = await api.createCase(body, { utcOffset });

        // Precache ui-definition
        if (response && response.data && response.data.caseContext && response.data.caseType) {
          const returnedCaseTypeId = response.data.caseType.v;
          const returnedCaseContextId = response.data.caseContext.v;
          dispatch(responseCachingActionCreators.getUiDefinition(returnedCaseTypeId, returnedCaseContextId));
        }
        isCaseViewModalOpen() ?
          navigate.toDraftCaseViewModal(draftId) :
          navigate.toDraft(draftId);
      } catch (err) {
        dispatch(new CreateNewDraftFailure(caseTypeId, err));
        if (err.response?.status === HttpStatusCodes.TOO_MANY_REQUESTS) {
          const errorText = translate(headerTranslation.message_too_many_requests);
          dispatch(new ErrorNotification(errorText));
          navigate.toSelectCaseTypes(false);
        } else {
          navigate.toStartupView();
        }
      }
    }
});
